import { fetchData } from "../fetchData";

export const getBoards = (filters) => fetchData("v1/sv/masters/board", filters);
export const getMediums = (filters) => fetchData("v1/sv/masters/medium", filters);
export const getGrades = (filters) => fetchData("v1/sv/masters/grade", filters);
export const getSections = (filters) => fetchData("v1/section", filters);
